// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__15Vph","inputWrap":"Table_inputWrap__1Ad2f","col":"Table_col__zqwzP","bmiTooltip":"Table_bmiTooltip__18Skc"};